import { FC, useEffect, useRef } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, useWatch } from 'react-hook-form';
import { toast } from 'react-toastify';
import buttonStyles from '@/components/controls/Button/Button.module.scss';
import { InputFile } from '@/components/controls/InputFile/InputFile.component';
import { schema } from '@/components/forms/GallerySourceForm/GallerySourceForm.config';
import {
    GallerySourceFormDataIF,
    GallerySourceFormPropsIF,
} from '@/components/forms/GallerySourceForm/GallerySourceForm.types';

const GallerySourceForm: FC<GallerySourceFormPropsIF> = ({
    addFiles,
    isDisabled,
    isMulti,
    className,
    children,
    buttonVariant,
}) => {
    const previousImagesRef = useRef<FileList | null>(null);

    const {
        control,
        formState: { errors },
    } = useForm<GallerySourceFormDataIF>({
        mode: 'onChange',
        resolver: yupResolver(schema),
    });

    const images = useWatch({
        name: 'images',
        control,
    });

    useEffect(() => {
        if (!images || images === previousImagesRef.current) {
            return;
        }

        previousImagesRef.current = images;

        addFiles(Array.from(images));
    }, [images]);

    useEffect(() => {
        if (errors?.images?.message) {
            toast.error(errors.images.message);
        }
    }, [errors]);

    const variantClassName = buttonVariant
        ? `${buttonStyles.button} ${buttonStyles[buttonVariant]}`
        : '';

    return (
        <InputFile
            name="images"
            control={control}
            className={`${className} ${variantClassName}`}
            acceptType="image"
            isCustom
            isMulti={isMulti}
            isDisabled={isDisabled}
        >
            {children}
        </InputFile>
    );
};

export default GallerySourceForm;
